module.exports = __webpack_public_path__ + "img/UpperLatvia.709c674d.png";